export default (state = null, action) => {
  switch (action.type) {
    case 'INCIDENT_RESPONSE_TIME':
      return action.payload.incidentResponseTime;
    default:
      return state;
  }
};
